import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
   copyQuota,
   getQuotaDetails,
   setState,
   submitQuota,
} from "./quotaCopySlice";
import {
   getCloneDates,
   getCountryIDString,
   getValidityDates,
} from "./quotaCopyUtils";
import dayjs from "dayjs";

export default function ButtonGroup() {
   const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quotaCopy);
   const {
      quotaDetails,
      selectedTableRows,
      selectedCountries,
      countries,
      targetPeriods,
      selectedTargetPeriod,
      sourcePeriods,
      selectedSourcePeriod,
      selectedPeriodType,
      quotaDetailsTable,
   } = state;

   function getDateFromDayjsDate(date) {
      let outputDate = null;

      const year = date.year();
      const month = date.month() + 1;
      const day = date.date();
      const time = new Date();
      const formattedTime = time.toLocaleTimeString("en-US", {
         hour12: false,
         hour: "2-digit",
         minute: "2-digit",
         second: "2-digit",
      });
      outputDate = `${year}-${month < 10 ? "0" + month : month}-${
         day < 10 ? "0" + day : day
      }T${formattedTime}`;

      return outputDate;
   }

   function search() {
      const idList = getCountryIDString(selectedCountries, countries);
      const { validityStartDate, validityEndDate } = getValidityDates(
         targetPeriods,
         selectedTargetPeriod
      );
      const { cloneStartDate, cloneEndDate } = getCloneDates(
         sourcePeriods,
         selectedSourcePeriod
      );

      const obj = {
         countryIDList: idList,
         periodType: selectedPeriodType,
         validityStartDate,
         validityEndDate,
         cloneStartDate,
         cloneEndDate,
      };
      dispatch(getQuotaDetails(obj));
   }

   function copy() {
      if (selectedTableRows.length === 0) {
         dispatch(setState("isError", true));
         dispatch(setState("isErrorMsg", "Please select a scenario."));
         return;
      }
      const user = JSON.parse(localStorage.getItem("data"));
      const { cloneStartDate, cloneEndDate } = getCloneDates(
         sourcePeriods,
         selectedSourcePeriod
      );

      let list = [];

      for (let i = 0; i < selectedTableRows.length; ++i) {
         const tempQuota = quotaDetails[selectedTableRows[i]];
         console.log(tempQuota);
         const quota = {
            countryId: tempQuota.geoID,
            effectiveEndDate: cloneEndDate,
            effectiveStartDate: cloneStartDate,
            quotaID: tempQuota.quotaID,
            scenarioID: tempQuota.scenarioID,
            scenarioName: tempQuota.scenarioName,
            updatedBy: `${user.firstName} ${user.lastName}`,
            updatedDate: getDateFromDayjsDate(dayjs()),
            user,
         };
         const validityPeriod = {
            displayDate: tempQuota.period,
            endDate: tempQuota.effectiveEndDate,
            startDate: tempQuota.effectiveStartDate,
         };
         const obj = {
            quota,
            validityPeriod,
         };
         list.push(obj);
      }
      console.log("Define_QuotaCopySubmit_copy", list);
      dispatch(copyQuota(list)).then(() => search());
      resetSelections();
   }

   function submit() {
      if (selectedTableRows.length === 0) {
         dispatch(setState("isError", true));
         dispatch(setState("isErrorMsg", "Please select a scenario."));
         return;
      }
      const user = JSON.parse(localStorage.getItem("data"));
      const { cloneStartDate, cloneEndDate } = getCloneDates(
         sourcePeriods,
         selectedSourcePeriod
      );

      let list = [];

      for (let i = 0; i < selectedTableRows.length; ++i) {
         const tempQuota = quotaDetails[selectedTableRows[i]];
         const quota = {
            countryId: tempQuota.geoID,
            effectiveEndDate: cloneStartDate,
            effectiveStartDate: cloneEndDate,
            quotaID: tempQuota.quotaID,
            scenarioID: tempQuota.scenarioID,
            scenarioName: tempQuota.scenarioName,
            updatedBy: `${user.firstName} ${user.lastName}`,
            updatedDate: getDateFromDayjsDate(dayjs()),
            user,
         };
         const validityPeriod = {
            displayDate: tempQuota.period,
            endDate: tempQuota.effectiveEndDate,
            startDate: tempQuota.effectiveStartDate,
         };
         const obj = {
            quota,
            validityPeriod,
         };
         list.push(obj);
      }
      console.log("Define_QuotaCopySubmit_submit", list);
      dispatch(submitQuota(list)).then(() => search());
      resetSelections();
   }

   function resetSelections() {
      const tableRows = quotaDetailsTable.rows.map((item) => {
         return {
            ...item,
            checked: false,
         };
      });
      dispatch(setState("quotaDetailsTable", { rows: tableRows }));
      dispatch(setState("selectedTableRow", []));
      dispatch(setState("selectedTableRows", []));
      dispatch(setState("tableColChecked", false));
   }

   return (
      <Box
         sx={{
            display: "flex",
            alignContent: "flex-end",
            ml: "calc(100% - 254px)",
            mt: 2,
         }}
      >
         <Button
            sx={{
               bgcolor: "blue.main",
               color: "white.main",
               textTransform: "none",
               fontWeight: "bold",
               mt: 1,
               mx: 1,
               "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
               },
            }}
            disabled = {!isRestrictedAccess}
            onClick={copy}
         >
            Copy
         </Button>

         <Button
            sx={{
               bgcolor: "blue.main",
               color: "white.main",
               textTransform: "none",
               fontWeight: "bold",
               mt: 1,
               mx: 1,
               "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
               },
            }}
            disabled = {!isRestrictedAccess}
            onClick={submit}
         >
            Submit
         </Button>
      </Box>
   );
}
